module.exports = __webpack_public_path__ + "img/img16.6d6f8a8a.svg";